import { useEffect, useRef } from 'react';

const DISMISS_STORAGE_KEY = 'bx_notification_prompt_dismissed';

/**
 * Opt-in browser notification permission prompt (decoupled from push backend).
 */
export const useBrowserNotificationOptIn = () => {
  const promptedRef = useRef(false);

  useEffect(() => {
    if (promptedRef.current) {
      return undefined;
    }
    if (typeof window === 'undefined' || !('Notification' in window)) {
      return undefined;
    }
    if (Notification.permission !== 'default') {
      return undefined;
    }
    if (window.localStorage.getItem(DISMISS_STORAGE_KEY) === '1') {
      return undefined;
    }

    promptedRef.current = true;

    const timerId = window.setTimeout(() => {
      Notification.requestPermission().then(result => {
        if (result === 'denied') {
          window.localStorage.setItem(DISMISS_STORAGE_KEY, '1');
        }
      });
    }, 4000);

    return () => window.clearTimeout(timerId);
  }, []);
};
